
<template>
  <div>
    <Header />
    <br/>
    <div class="md-layout md-alignment-top-center">
      <div class="md-layout-item md-size-20" style="padding-right: 16px;">
        <md-card>
          <md-card-header>
            <div class="md-title">Movimentação de hoje</div>
          </md-card-header>

          <md-card-content>R$ {{payload.currentDay}}</md-card-content>
        </md-card>
      </div>
      
      <div class="md-layout-item md-size-20">
        <md-card>
          <md-card-header>
            <div class="md-title">Movimentação de ontem</div>
          </md-card-header>

          <md-card-content>R$ {{payload.lastDay}}</md-card-content>
        </md-card>
      </div>       
    </div>
    
    <br/>
    <div class="md-layout md-alignment-top-center">
      <div class="md-layout-item md-size-40">
        <md-card>
          <md-card-header>
            <div class="md-title">Movimentação mensal</div>
          </md-card-header>
         
          <md-card-content>
              <div class="chartData">
                
              </div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<style>
.chartData{
    max-width:500px;
    margin: 0 auto; 
}
</style>

<script>
import Header from "@/components/Header.vue";

import {mapState,mapActions} from 'vuex'



export default {
  components: {
    Header,    
  },
  computed:{
    ...mapState("AdmDashboard",["payload"])
  },
  methods:{
    ...mapActions("AdmDashboard",["setList"]),
  },
  created(){ 
     
    //https://saigesp.github.io/vue-d3-charts/#/

    this.setList()
        
  },
  
};
</script>
